import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import {
  SERVICO_ENDPOINT,
} from '../../utils/api/domain/domain-endpoint-utils';

async function fetchAll() {
  return doGetQCXRequest([
    SERVICO_ENDPOINT
  ]);
}

async function fetchById(id) {
  return doGetQCXRequest([
    SERVICO_ENDPOINT,
    id,
  ]);
}

async function register(data, queryParams = []) {
  return doPostQCXRequest(
    [SERVICO_ENDPOINT],
    data,
    queryParams
  );
}

async function save(data, queryParams = []) {
  return doPutQCXRequest(
    [SERVICO_ENDPOINT],
    data,
    queryParams
  );
}

async function activateById(id) {
  return doPutQCXActivateRequest(
    [SERVICO_ENDPOINT],
    id
  );
}

async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [SERVICO_ENDPOINT],
    id
  );
}

async function fetchByFilterDto(queryParams = []) {
  return doGetQCXRequest([SERVICO_ENDPOINT, 'filter/dto'], queryParams);
}

const servicoAPI = {
  fetchAll,
  fetchById,
  register,
  save,
  activateById,
  inactivateById,
  fetchByFilterDto,
};

export {
  servicoAPI,
  fetchAll,
  fetchById,
  register,
  save,
  activateById,
  inactivateById,
  fetchByFilterDto,
};
